<template>
    <DCard
        padding
    >
        <Form
            :country="country"
            :errors="props.errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/Countries/States/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    country: {
        type: Object,
        default: () => ({})
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const submitData = (form) => {
    form.post(route('settings.countries.states.store', { country: props.country.country_code }))
}
</script>
